import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getAjeerRenewData = createAsyncThunk(
  "api/ajeer?renew=1",
  async (token) => {
    try {
      const response = await nodeinstance.get("/ajeer?renew=1", {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("renew data to be printed in the console",response)
      return response.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
);

const AjeerRenewDataSlice = createSlice({
  name: "absher",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAjeerRenewData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getAjeerRenewData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getAjeerRenewData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getAjeerRenewData };
export default AjeerRenewDataSlice.reducer;
